import { ReactNode } from "react";
import { theme, size } from "../../../../../helpers/theme";
import { ReactComponent as Image } from "../../../../../assets/icons/img_with_button.svg";
import Icon from "../../../../../components/icon";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { url } from "../../../../../utils/url";


import aboutUsImage from "../../../../../assets/icons/about_us.png"
import customerService from "../../../../../assets/icons/customer_service.png"
import { StyledButton } from "../../../../../components/Button/button";


const title = 'Przestrzeń magazynowa do wynajęcia';
const titleButton = 'Złóż zamówienie';

export const ImagesSection = () => {
    const navigate = useNavigate();
    return (
        <TwoImageContainer>
            <ImageSection

                style={{
                    backgroundImage: `url(${aboutUsImage})`,
                    backgroundSize: 'cover',
                }}>

                <Etykieta>O nas</Etykieta>
                <ImageTitle>Logistyka w ujęciu <br /> holistycznym <br />i innowacyjnym</ImageTitle>
                <StyledButton
                    onClick={() => navigate(url.aboutUs)}
                    sx={{
                        width: '194px',
                        height: '56px',
                        fontSize: '16px',
                        lineHeight: '24px',
                    }}
                >
                    Dowiedz się więcej
                </StyledButton>
            </ImageSection >

            <ImageSection
                style={{
                    backgroundImage: `url(${customerService})`,
                    backgroundSize: 'cover',
                }}>
                <Etykieta>Obsługa klienta</Etykieta>
                <ImageTitle>Chciałbyś zadać nam <br />pytanie? Skontaktuj <br />się z nami</ImageTitle>
                <StyledButton
                    onClick={() => navigate(url.contact)}
                    sx={{
                        width: '194px',
                        height: '56px',
                        fontSize: '16px',
                        lineHeight: '24px',
                    }}
                >
                    Kontakt
                </StyledButton>
            </ImageSection >

        </TwoImageContainer >



    );
};


const Etykieta = styled.p`
font-family:${theme.fonts.interBold};
font-weight:${theme.fontWeight.big};
font-size:14px;
line-height:20px;
color:${theme.colors.black_primaryText};
background-color:${theme.colors.white};
padding:5px 12px;
border-radius:8px;
width: max-content;
margin-bottom:0px;
`
const ImageTitle = styled.h2`
font-family:${theme.fonts.interRegular};
font-weight:${theme.fontWeight.big};
font-size:32px;
line-height:40px;
color:${theme.colors.white};
width: 70%;
margin-bottom:24px;
margin-top:5px;

 @media(min-width: 580px) {
    font-size:32px;
    line-height:40px;
    width: 70%;
 }
 @media(min-width: 401px) {
    font-size:28px;
    line-height:36px;
    width: 100%;
  }
  @media(min-width: 206px) {
    font-size:24px;
    line-height:32px;
    width: 100%;
  }
`
const TwoImageContainer = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
width:100%;
& div:first-child {
    margin-right:24px;
}

 @media (max-width: ${size.laptop}) {
     flex-direction:column;
     
     & div:first-child {
         margin-right:0px;
         margin-bottom:24px;
 }
`
const ImageSection = styled.div`
padding:48px;
padding-top:200px;
display: flex;
flex-direction: column;
justify-content: flex-end;
border-radius: 8px;
width:50%;
background-repeat: no-repeat;
background-position: center; 

@media (max-width: ${size.laptop}) {
    width: auto;
 }
 @media(max-width: 401px) {
    padding-left:16px;
    padding-right:16px;
    padding-top:150px;
 }
`;

